<template>
  <SidebarComponent />
  <div class="dashboard-layout public-reminders-page">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Promemoria pubblici</h1>
        </div>

        <div class="promemoria-container">

<button type="button" @click="toggleFilters" class="filter-toggle-button staff-reminder-filter-toggle staff-reminder-action" :aria-expanded="showFilters" aria-controls="public-reminder-filters">
  <span class="material-icons" aria-hidden="true">tune</span>
  <span>{{ showFilters ? "Nascondi filtri" : "Mostra filtri" }}</span>
</button>

          <!-- Bottone crea promemoria flottante -->
          <button type="button" @click="openAddReminderModal" class="fab-create-small staff-reminder-create staff-reminder-action" title="Crea promemoria" aria-label="Crea promemoria">
            <span class="material-icons" aria-hidden="true">add</span>
            <span>Nuovo</span>
          </button>
<div v-if="isLoading" class="loader">
  <h4>Caricamento in corso…</h4>
</div>
<p v-if="errorMessage" class="reminder-error" role="alert">{{ errorMessage }}</p>


<FilterModulePromemoria
  id="public-reminder-filters"
  ref="filterModule"
  :visible="showFilters"
  :initialFilters="initialFilters"
  :busy="isLoading || savingReminderIds.size > 0"
  @start-advanced-search="applyAdvancedSearch"
  @close="showFilters = false"
/>


          <section v-if="filteredReminders.length" class="staff-reminders-panel" aria-label="Elenco promemoria">
            <div class="staff-reminders-summary">
              <strong>{{ filteredReminders.length }} promemoria</strong>
              <p id="staff-reminders-scroll-help">
                <span class="reminder-desktop-only">Scorri la tabella: l’utente resta sempre visibile.</span>
                <span class="reminder-mobile-only">Apri “Altri campi” per studio, stato, note e altri dettagli.</span>
              </p>
            </div>
            <div
              class="staff-reminders-scroll"
              tabindex="0"
              role="region"
              aria-label="Tabella promemoria"
              aria-describedby="staff-reminders-scroll-help"
            >
              <table class="reminders-table staff-reminders-table">
                <caption class="staff-reminders-sr-only">
                  Promemoria pubblici: contatti, appuntamenti e attività
                </caption>
                <colgroup>
                  <col style="width: 250px" />
                  <col style="width: 174px" />
                  <col style="width: 204px" />
                  <col style="width: 146px" />
                  <col style="width: 120px" />
                  <col style="width: 300px" />
                  <col style="width: 254px" />
                  <col style="width: 244px" />
                  <col style="width: 174px" />
                  <col style="width: 144px" />
                  <col style="width: 140px" />
                  <col style="width: 280px" />
                  <col style="width: 148px" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">Utente</th>
                    <th scope="col">Quando</th>
                    <th scope="col">Attività</th>
                    <th scope="col">Stato</th>
                    <th scope="col">Urgenza</th>
                    <th scope="col">Note</th>
                    <th scope="col">Assegnato a</th>
                    <th scope="col">Esito</th>
                    <th scope="col">Fatto da</th>
                    <th scope="col">Acquistato</th>
                    <th scope="col">Importo</th>
                    <th scope="col">Note generali</th>
                    <th scope="col">Visibilità</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="m in filteredReminders"
                    :key="m.id"
                    :class="{
                      'new-row': m.isNew,
                      'reminder-completed': completingReminderIds.has(m.id),
                      'reminder-expanded': expandedReminderIds.has(m.id),
                    }"
                  >
                    <td data-label="Utente" class="staff-reminder-identity-cell reminder-wide">
                      <div class="staff-reminder-identity-layout">
                        <div class="staff-reminder-identity-info">
                          <div class="reminder-person">
                            <strong>
                              {{ [m.userName, m.userSurname].filter(Boolean).join(" ") || "Utente senza nome" }}
                            </strong>
                            <span class="reminder-secondary">{{ m.userStudio || "Studio non indicato" }}</span>
                          </div>
                          <div class="staff-reminder-contacts">
                            <a v-if="m.userEmail" class="staff-reminder-contact-link staff-reminder-email-link" :href="'mailto:' + m.userEmail" :title="m.userEmail">
                              {{ m.userEmail }}
                            </a>
                            <span v-else class="staff-reminder-contact-empty">Email non indicata</span>
                            <a
                              v-if="m.userPhone"
                              class="staff-reminder-contact-link"
                              :href="'tel:' + String(m.userPhone).replace(/[^\d+]/g, '')"
                            >
                              {{ m.userPhone }}
                            </a>
                            <span v-else class="staff-reminder-contact-empty">Telefono non indicato</span>
                          </div>
                        </div>
                        <div class="staff-reminder-user-actions reminder-secondary" role="group" aria-label="Azioni promemoria">
                          <button
                            type="button"
                            class="staff-reminder-icon-button staff-button-neutral"
                            @click="viewUserProfile(m.uid)"
                            title="Vai al profilo"
                            aria-label="Vai al profilo"
                          >
                            <span class="material-icons" aria-hidden="true">account_circle</span>
                          </button>
                          <button
                            type="button"
                            class="staff-reminder-icon-button staff-button-neutral"
                            @click="openReminderDetails(m)"
                            title="Dettagli promemoria"
                            aria-label="Dettagli promemoria"
                          >
                            <span class="material-icons" aria-hidden="true">description</span>
                          </button>
                          <button
                            type="button"
                            class="staff-reminder-icon-button staff-button-danger"
                            @click="deleteReminder(m.id)"
                            title="Elimina promemoria"
                            aria-label="Elimina promemoria"
                          >
                            <span class="material-icons" aria-hidden="true">delete</span>
                          </button>
                        </div>
                      </div>
                    </td>
                    <td data-label="Quando" class="staff-reminder-when-cell reminder-wide">
                      <div class="staff-reminder-when-fields">
                        <label>
                          <span>Data</span>
                          <input
                            type="date"
                            aria-label="Data promemoria"
                            :value="getDateString(m.data)"
                            @blur="updateReminderDate(m, $event.target.value, null)"
                          />
                        </label>
                        <label>
                          <span>Orario</span>
                          <input
                            type="time"
                            aria-label="Orario promemoria"
                            :value="getTimeString(m.data)"
                            @blur="updateReminderDate(m, null, $event.target.value)"
                          />
                        </label>
                      </div>
                    </td>
                    <td data-label="Attività" class="reminder-type-cell reminder-wide">
                      <select
                        v-model="m.tipo"
                        aria-label="Attività promemoria"
                        @change="updateReminderField(m, 'tipo')"
                      >
                        <option value="telefonata">Chiamata</option>
                        <option value="prima telefonata">Prima chiamata</option>
                        <option value="whatsapp">Whatsapp</option>
                        <option value="email">E-mail</option>
                        <option value="live">Dal vivo</option>
                        <option value="messaggio">Messaggio</option>
                        <option value="check confronto">Check di confronto</option>
                        <option value="check lavorare">Check lavorare</option>
                        <option value="ricontatto intermedio">Ricontatto intermedio</option>
                        <option value="ricontatto finale">Ricontatto finale</option>
                        <option value="recupero clienti fermi">Recupero clienti fermi</option>
                        <option value="altro">Altro</option>
                      </select>
                    </td>
                    <td data-label="Stato" class="reminder-status-cell reminder-secondary">
                      <select
                        :value="m.fatto"
                        :disabled="isLoading || savingReminderIds.has(m.id)"
                        @change="updateReminderStatus(m, $event.target.value)"
                        aria-label="Stato promemoria"
                      >
                        <option value="si">Fatto</option>
                        <option value="no">Non Fatto</option>
                        <option value="da fare">Da fare</option>
                      </select>
                    </td>
                    <td data-label="Urgenza" class="reminder-urgency-cell reminder-secondary" :data-urgency="m.urgenza">
                      <select
                        v-model="m.urgenza"
                        aria-label="Urgenza promemoria"
                        @change="updateReminderField(m, 'urgenza')"
                      >
                        <option value="bassa">Bassa</option>
                        <option value="media">Media</option>
                        <option value="alta">Alta</option>
                      </select>
                    </td>
                    <td data-label="Note" class="reminder-note-cell reminder-secondary reminder-wide">
                      <textarea
                        class="staff-reminder-note-editor"
                        v-model="m.note"
                        @blur="updateReminderField(m, 'note')"
                        rows="3"
                        placeholder="Aggiungi nota"
                        aria-label="Note promemoria"
                      ></textarea>
                    </td>
                    <td
                      data-label="Assegnato a"
                      class="staff-reminder-assigned-cell reminder-secondary reminder-wide"
                    >
                      <div class="staff-reminder-assignees">
                        <div v-for="(email, idx) in m.assignedEmailList" :key="idx">
                          <input
                            type="text"
                            v-model="m.assignedEmailList[idx]"
                            :title="m.assignedEmailList[idx]"
                            aria-label="Email collaboratore"
                            @blur="updateAssignedEmail(m)"
                          />
                        </div>
                        <button
                          type="button"
                          class="staff-reminder-icon-button staff-button-positive"
                          @click="addAssignedEmail(m)"
                          title="Aggiungi collaboratore"
                          aria-label="Aggiungi collaboratore"
                        >
                          <span class="material-icons" aria-hidden="true">person_add</span>
                        </button>
                      </div>
                    </td>
                    <td data-label="Esito" class="reminder-secondary reminder-wide">
                      <select
                        v-model="m.stato3"
                        aria-label="Esito promemoria"
                        @change="updateReminderField(m, 'stato3')"
                      >
                        <option value="">Seleziona</option>
                        <option value="da ricontattare">Da ricontattare</option>
                        <option value="fissato app in studio">Fissato App in studio</option>
                        <option value="telefonata riprogrammata">Telefonata Riprogrammata</option>
                        <option value="In Attesa di finalizzazione">In Attesa di Finalizzazione</option>
                        <option value="non risponde">Non risponde</option>
                        <option value="non interessata">Non interessata</option>
                      </select>
                    </td>
                    <td data-label="Fatto da" class="reminder-secondary">
                      <select v-model="m.da" aria-label="Fatto da" @change="updateReminderField(m, 'da')">
                        <option value="">-</option>
                        <option value="alessandro">Alessandro</option>
                        <option value="alessiofantini">Alessio Fantini</option>
                        <option value="Gaetano">Gaetano</option>
                        <option value="Luca">Luca Corbella</option>
                        <option value="lucadelfino">Luca Delfino</option>
                        <option value="Paolomarchini">Paolo Marchini</option>
                        <option value="Paoloramunno">Paolo Ramunno</option>
                        <option value="pasquale">Pasquale</option>
                        <option value="rayen">Rayen</option>
                        <option value="mirko">Mirko</option>
                        <option value="Roberta">Roberta</option>
                        <option value="Salvatore">Salvatore</option>
                        <option value="stefania">Stefania</option>
                      </select>
                    </td>
                    <td data-label="Acquistato" class="reminder-secondary">
                      <select
                        v-model="m.acquistato"
                        aria-label="Acquistato"
                        @change="updateReminderField(m, 'acquistato')"
                      >
                        <option value="">Seleziona</option>
                        <option value="Si">Si</option>
                        <option value="No">No</option>
                        <option value="In attesa">In attesa</option>
                      </select>
                    </td>
                    <td data-label="Importo" class="reminder-secondary">
                      <input
                        type="text"
                        v-model="m.importo"
                        aria-label="Importo"
                        @change="updateReminderField(m, 'importo')"
                        placeholder="Importo"
                      />
                    </td>
                    <td data-label="Note generali" class="note-generali-cell reminder-secondary reminder-wide">
                      <div class="staff-reminder-general-notes">{{ m.userNotes || "N/A" }}</div>
                    </td>
                    <td data-label="Visibilità" class="reminder-secondary">
                      <select
                        v-model="m.tipoPromemoria"
                        aria-label="Visibilità promemoria"
                        @change="updateReminderField(m, 'tipoPromemoria')"
                      >
                        <option value="pubblico">Pubblico</option>
                        <option value="privato">Privato</option>
                      </select>
                    </td>
                    <td class="reminder-footer-cell staff-reminder-mobile-footer reminder-mobile-only reminder-wide">
                      <button
                        type="button"
                        class="reminder-mobile-only reminder-expand-button staff-reminder-action staff-button-neutral"
                        :aria-expanded="expandedReminderIds.has(m.id)"
                        @click="toggleReminderFields(m.id)"
                      >
                        {{ expandedReminderIds.has(m.id) ? "Meno campi" : "Altri campi" }}
                        <span class="material-icons" aria-hidden="true">
                          {{ expandedReminderIds.has(m.id) ? "expand_less" : "expand_more" }}
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <p v-else-if="!isLoading && !errorMessage">Nessun promemoria pubblico disponibile.</p>
        </div>


<dialog
  ref="newReminderDialog"
  class="staff-editor-dialog staff-reminder-create-dialog"
  aria-labelledby="staff-reminder-create-title"
  aria-describedby="staff-reminder-create-description"
  @cancel.prevent="closeAddReminderModal"
  @close="showAddModal = false"
  @click.self="handleAddReminderBackdrop"
>
  <header class="staff-editor-header">
    <span class="material-icons staff-editor-heading-icon" aria-hidden="true">add_task</span>
    <div>
      <h2 id="staff-reminder-create-title">Nuovo promemoria</h2>
      <p id="staff-reminder-create-description">Pianifica l’attività e scegli a chi assegnarla.</p>
    </div>
    <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi nuovo promemoria" title="Chiudi nuovo promemoria" @click="closeAddReminderModal" autofocus>
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <form class="staff-editor-form" @submit.prevent="addReminder">
    <div class="staff-editor-body">
      <fieldset class="staff-editor-section">
        <legend>Pianificazione</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field">
            <span>Data e ora *</span>
            <input type="datetime-local" v-model="newReminder.data" required />
          </label>
          <label class="staff-editor-field">
            <span>Visibilità</span>
            <select v-model="newReminder.tipoPromemoria">
              <option value="pubblico">Pubblico</option>
              <option value="privato">Privato</option>
            </select>
          </label>
          <label class="staff-editor-field">
            <span>Tipo di attività</span>
            <select v-model="newReminder.tipo">
              <option value="" disabled>Seleziona attività</option>
              <option value="telefonata">Chiamata</option>
              <option value="prima telefonata">Prima chiamata</option>
              <option value="whatsapp">Whatsapp</option>
              <option value="email">E-mail</option>
              <option value="live">Dal vivo</option>
              <option value="messaggio">Messaggio</option>
              <option value="check confronto">Check di confronto</option>
              <option value="check lavorare">Check lavorare</option>
              <option value="ricontatto intermedio">Ricontatto intermedio</option>
              <option value="ricontatto finale">Ricontatto finale</option>
              <option value="recupero clienti fermi">Recupero clienti fermi</option>
              <option value="altro">Altro</option>
            </select>
          </label>
          <label class="staff-editor-field">
            <span>Urgenza</span>
            <select v-model="newReminder.urgenza">
              <option value="" disabled>Seleziona urgenza</option>
              <option value="bassa">Bassa</option>
              <option value="media">Media</option>
              <option value="alta">Alta</option>
            </select>
          </label>
        </div>
      </fieldset>

      <fieldset class="staff-editor-section">
        <legend>Persone e assegnazioni</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field">
            <span>Email utente</span>
            <input type="text" inputmode="email" v-model="newReminder.userEmail" :disabled="newReminderPrefillLoading" placeholder="Email dell’utente" @input="clearLinkedReminderUser" />
            <small v-if="newReminderPrefillLoading" role="status">Caricamento dell’utente…</small>
            <small v-else-if="newReminderPrefillError" class="staff-editor-field-error" role="alert">{{ newReminderPrefillError }}</small>
            <small v-else-if="newReminderTargetUid">Utente recuperato dal monitoraggio.</small>
          </label>
          <label class="staff-editor-field">
            <span>Collaboratori</span>
            <input type="text" inputmode="email" v-model="newReminder.assignedEmail" placeholder="email1@mail.com, email2@mail.com" aria-describedby="staff-reminder-collaborators-hint" />
            <small id="staff-reminder-collaborators-hint">Separa più indirizzi con una virgola.</small>
          </label>
        </div>
      </fieldset>

      <label class="staff-editor-field staff-editor-field--wide">
        <span>Note</span>
        <textarea v-model="newReminder.note" rows="3" placeholder="Aggiungi le informazioni utili per l’attività"></textarea>
      </label>
    </div>

    <footer class="staff-editor-footer">
      <p>* Data e ora sono obbligatorie.</p>
      <div class="staff-editor-actions">
        <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeAddReminderModal">Annulla</button>
        <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive">
          <span class="material-icons" aria-hidden="true">check</span>
          <span>Salva</span>
        </button>
      </div>
    </footer>
  </form>
</dialog>


<dialog
  ref="reminderDetailsDialog"
  class="staff-editor-dialog staff-reminder-details-dialog"
  aria-labelledby="staff-reminder-details-title"
  aria-describedby="staff-reminder-details-description"
  @cancel.prevent="closeReminderDetails"
  @close="!reminderDetailsDialog?.open && closeReminderDetails()"
  @click.self="handleReminderDetailsBackdrop"
>
  <header class="staff-editor-header">
    <span class="material-icons staff-editor-heading-icon" aria-hidden="true">description</span>
    <div>
      <h2 id="staff-reminder-details-title">Dettagli promemoria</h2>
      <p id="staff-reminder-details-description">Obiettivi, indicazioni e note della chiamata.</p>
    </div>
    <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi dettagli promemoria" title="Chiudi dettagli promemoria" @click="closeReminderDetails" autofocus>
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <form v-if="currentReminder" class="staff-editor-form" @submit.prevent="saveReminderDetails">
    <div class="staff-editor-body">
      <fieldset class="staff-editor-section">
        <legend>Percorso e indicazioni</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field">
            <span>Obiettivi</span>
            <select v-model="currentReminder.objectives">
              <option value="">Seleziona</option>
              <option value="dimagrimento">Dimagrimento</option>
              <option value="tonificazione">Tonificazione</option>
              <option value="ricomposizione corporea">Ricomposizione corporea</option>
            </select>
          </label>
          <label class="staff-editor-field">
            <span>Esperienza allenamento</span>
            <select v-model="currentReminder.trainingExperience">
              <option value="">Seleziona</option>
              <option value="principiante">Principiante</option>
              <option value="intermedia">Intermedia</option>
              <option value="esperta">Esperta</option>
            </select>
          </label>
          <label class="staff-editor-field">
            <span>Patologie</span>
            <textarea v-model="currentReminder.pathologie" rows="3" placeholder="Patologie note"></textarea>
          </label>
          <label class="staff-editor-field">
            <span>Consiglio</span>
            <textarea v-model="currentReminder.consiglio" rows="3" placeholder="Consiglio della consulente"></textarea>
          </label>
        </div>
      </fieldset>

      <fieldset class="staff-editor-section">
        <legend>Chiamata</legend>
        <div class="staff-editor-grid staff-editor-grid--two">
          <label class="staff-editor-field">
            <span>Operatore</span>
            <select v-model="currentReminder.operatore">
              <option value="">Seleziona</option>
              <option value="Veronica">Veronica</option>
              <option value="Michela">Michela</option>
              <option value="Svetlana">Svetlana</option>
              <option value="Giorgia">Giorgia</option>
              <option value="Chiara">Chiara</option>
              <option value="Simona">Simona</option>
              <option value="Angy">Angy</option>
              <option value="Noemi">Noemi</option>
              <option value="Eleonora">Eleonora</option>
              <option value="Sonia">Sonia</option>
              <option value="Marika">Marika</option>
              <option value="Paolomarchini">Paolo Marchini</option>
              <option value="Roberta">Roberta</option>
              <option value="Gaetano">Gaetano</option>
              <option value="Salvatore">Salvatore</option>
              <option value="Paoloramunno">Paolo Ramunno</option>
              <option value="Luca">Luca Corbella</option>
            </select>
          </label>
          <label class="staff-editor-field">
            <span>Note chiamata</span>
            <textarea v-model="currentReminder.notecontatto1" rows="3" placeholder="Note chiamata"></textarea>
          </label>
        </div>
      </fieldset>
    </div>

    <footer class="staff-editor-footer">
      <p>Le modifiche si applicano con Salva.</p>
      <div class="staff-editor-actions">
        <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeReminderDetails">Annulla</button>
        <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive">
          <span class="material-icons" aria-hidden="true">check</span>
          <span>Salva</span>
        </button>
      </div>
    </footer>
  </form>
</dialog>



      </div>
    </div>
  </div>
</template>

<script>
import SidebarComponent from '../SidebarComponent.vue';
import FilterModulePromemoria from '../module/FilterModule_promemoria.vue'; 
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { createPublicReminderFilters, getReminderDateRange } from '../../lib/publicReminderFilters';
import {
  getFirestore,
  collection,
  query,
  where,
  updateDoc,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  addDoc,
  orderBy,
  Timestamp
} from 'firebase/firestore';

export default {
  name: 'PromemoriaPubblici',
  components: {
    SidebarComponent,
    FilterModulePromemoria
  },
  setup() {
    const db = getFirestore();
    const router = useRouter();
    const route = useRoute();
const showFilters = ref(false);
    const expandedReminderIds = ref(new Set());
    const toggleReminderFields = id => {
      if (expandedReminderIds.value.has(id)) expandedReminderIds.value.delete(id);
      else expandedReminderIds.value.add(id);
    };
    const publicReminders = ref([]);
    const filteredReminders = ref([]);
const isLoading = ref(true);
    const initialFilters = createPublicReminderFilters();
    const errorMessage = ref('');
    const savingReminderIds = ref(new Set());
    const completingReminderIds = ref(new Set());
    const completionTimers = new Map();
    let disposed = false;
    let searchRequestId = 0;

    const cancelReminderCompletion = id => {
      if (completionTimers.has(id)) {
        clearTimeout(completionTimers.get(id));
        completionTimers.delete(id);
      }
      completingReminderIds.value.delete(id);
    };

    const clearReminderCompletions = () => {
      completionTimers.forEach(timer => clearTimeout(timer));
      completionTimers.clear();
      completingReminderIds.value.clear();
    };


    const filterModule = ref(null);
	const showModalDetails = ref(false);
	const currentReminder = ref(null);
    const reminderDetailsDialog = ref(null);
    watch(showModalDetails, visible => {
      const dialog = reminderDetailsDialog.value;
      if (!dialog) return;
      if (visible && !dialog.open) dialog.showModal();
      else if (!visible && dialog.open) dialog.close();
    }, { flush: 'post' });
    const userCache = new Map();

    const parseDate = f => (f?.toDate ? f.toDate() : new Date(f));

    const chunkArray = (items, size) => {
      const chunks = [];
      for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size));
      }
      return chunks;
    };

    const getFilterDateRange = getReminderDateRange;

    const filterByDateRange = (rows, dateRange) => {
      if (!dateRange) return rows;
      return rows.filter(m => {
        const ts = parseDate(m.data).getTime();
        return ts >= dateRange.start.getTime() && ts <= dateRange.end.getTime();
      });
    };

    const getPublicReminderSnapshot = async ({ dateRange = null, fatto = '' } = {}) => {
      const constraints = [
        where('tipoPromemoria', '==', 'pubblico')
      ];

      if (fatto) {
        constraints.push(where('fatto', '==', fatto));
      }

      if (dateRange) {
        constraints.push(
          where('data', '>=', Timestamp.fromDate(dateRange.start)),
          where('data', '<=', Timestamp.fromDate(dateRange.end)),
          orderBy('data', 'asc')
        );
      }

      return getDocs(query(collection(db, 'comunicazioni'), ...constraints));
    };

    const fetchUsersMap = async uids => {
      const uniqueUids = Array.from(new Set(uids.filter(Boolean)));
      const usersMap = {};
      const missingUids = [];

      uniqueUids.forEach(uid => {
        if (userCache.has(uid)) {
          usersMap[uid] = userCache.get(uid);
        } else {
          missingUids.push(uid);
        }
      });

      const chunks = chunkArray(missingUids, 10);
      const snapshots = await Promise.all(
        chunks.map(chunk => getDocs(query(collection(db, 'users'), where('__name__', 'in', chunk))))
      );

      snapshots.forEach(userSnap => {
        userSnap.forEach(u => {
          const user = u.data();
          userCache.set(u.id, user);
          usersMap[u.id] = user;
        });
      });

      return usersMap;
    };

    const getReminderRows = docs => docs.map(d => ({ id: d.id, ...d.data() }));

    const hydrateReminderRows = async rows => {
      const usersMap = await fetchUsersMap(rows.map(m => m.uid));

      return rows.map(m => {
        const user = usersMap[m.uid] || {};
        return {
          ...m,
          userEmail: user.email || m.userEmail || '',
          userName: user.name || '',
          userSurname: user.surname || '',
          userPhone: user.phone || '',
          userStudio: user.studio || '',
          userNotes: user.notes || '',
          assignedEmailList: m.assignedEmail
            ? m.assignedEmail.split(',').map(e => e.trim())
            : []
        };
      });
    };

    const applyDocumentFilters = (rows, filters = {}) => {
      let filtered = filterByDateRange(rows, getFilterDateRange(filters));

      if (filters.tipo) {
        filtered = filtered.filter(m => m.tipo === filters.tipo);
      }

      if (filters.urgenza) {
        filtered = filtered.filter(m => m.urgenza === filters.urgenza);
      }

      if (filters.fatto) {
        filtered = filtered.filter(m => m.fatto === filters.fatto);
      }

      if (filters.assignedEmail) {
        const assignedEmail = filters.assignedEmail.toLowerCase();
        filtered = filtered.filter(m => m.assignedEmail?.toLowerCase().includes(assignedEmail));
      }

      if (filters.da) {
        filtered = filtered.filter(m => m.da === filters.da);
      }

      return filtered;
    };

    const applyClientFilters = (rows, filters = {}) => {
      let filtered = rows;

      if (filters.email) {
        const email = filters.email.toLowerCase();
        filtered = filtered.filter(m => m.userEmail?.toLowerCase().includes(email));
      }

      if (filters.studio && filters.studio.length) {
        filtered = filtered.filter(m => filters.studio.includes(m.userStudio));
      }

      return filtered;
    };

    const setReminderRows = rows => {
      clearReminderCompletions();
      const sorted = [...rows].sort((a, b) => parseDate(a.data) - parseDate(b.data));
      publicReminders.value = sorted;
      filteredReminders.value = sorted;
    };




const openReminderDetails = (m) => {
  currentReminder.value = { ...m }; // shallow copy per edit
  showModalDetails.value = true;
};

const closeReminderDetails = () => {
  currentReminder.value = null;
  showModalDetails.value = false;
};

const handleReminderDetailsBackdrop = event => {
  const rect = reminderDetailsDialog.value?.getBoundingClientRect();
  if (rect && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) {
    closeReminderDetails();
  }
};

const saveReminderDetails = async () => {
  try {
    const id = currentReminder.value.id;
    const fieldsToUpdate = {
      objectives: currentReminder.value.objectives || '',
      trainingExperience: currentReminder.value.trainingExperience || '',
      pathologie: currentReminder.value.pathologie || '',
      consiglio: currentReminder.value.consiglio || '',
      notecontatto1: currentReminder.value.notecontatto1 || '',
      operatore: currentReminder.value.operatore || ''
    };
    await updateDoc(doc(db, 'comunicazioni', id), fieldsToUpdate);

    // aggiorna localmente anche publicReminders
    const idx = publicReminders.value.findIndex(p => p.id === id);
    if (idx !== -1) {
      Object.assign(publicReminders.value[idx], fieldsToUpdate);
    }

    closeReminderDetails();
  } catch (e) {
    console.error("Errore nel salvataggio dettagli promemoria:", e);
  }
};


    const toggleFilters = () => {
      showFilters.value = !showFilters.value;
    };

    const newReminder = ref({
      data: '',
      tipo: '',
      urgenza: '',
      note: '',
      userEmail: '',
      assignedEmail: '',
      tipoPromemoria: 'pubblico'
    });

    const showAddModal = ref(false);
    const newReminderDialog = ref(null);
    const newReminderTargetUid = ref('');
    const newReminderPrefillLoading = ref(false);
    const newReminderPrefillError = ref('');
    let reminderCreateDeepLinkHandled = false;
    watch(showAddModal, visible => {
      const dialog = newReminderDialog.value;
      if (!dialog) return;
      if (visible && !dialog.open) dialog.showModal();
      else if (!visible && dialog.open) dialog.close();
    }, { flush: 'post' });

    const closeAddReminderModal = () => {
      showAddModal.value = false;
    };

    const handleAddReminderBackdrop = event => {
      const rect = newReminderDialog.value?.getBoundingClientRect();
      if (rect && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) {
        closeAddReminderModal();
      }
    };

    const openAddReminderModal = () => {
      newReminderPrefillError.value = '';
      showAddModal.value = true;
    };

    const clearLinkedReminderUser = () => {
      newReminderTargetUid.value = '';
      newReminderPrefillError.value = '';
    };

    const createDeepLinkUserId = () => {
      if (String(route.query?.create || '') !== '1') return '';
      const value = Array.isArray(route.query?.uid) ? route.query.uid[0] : route.query?.uid;
      const uid = String(value || '').trim();
      return /^[A-Za-z0-9_-]{6,128}$/.test(uid) ? uid : '';
    };

    const openReminderFromDeepLink = async () => {
      const uid = createDeepLinkUserId();
      if (!uid || reminderCreateDeepLinkHandled) return;
      reminderCreateDeepLinkHandled = true;
      showAddModal.value = true;
      newReminderPrefillLoading.value = true;
      newReminderPrefillError.value = '';
      try {
        const userSnapshot = await getDoc(doc(db, 'users', uid));
        if (!userSnapshot.exists()) throw new Error('Profilo utente non trovato.');
        const user = userSnapshot.data() || {};
        const email = String(user.email || user.emailLower || '').trim();
        if (!email) throw new Error('Il profilo non contiene un indirizzo email.');
        newReminder.value.userEmail = email;
        newReminderTargetUid.value = uid;
      } catch (error) {
        console.error('Errore precompilazione promemoria dal monitoraggio:', error);
        newReminderTargetUid.value = '';
        newReminderPrefillError.value = `${error.message || 'Utente non disponibile.'} Puoi inserire l’email manualmente.`;
      } finally {
        newReminderPrefillLoading.value = false;
      }
    };
    


    const applyAdvancedSearch = async filters => {
      if (savingReminderIds.value.size > 0) return;
      const requestId = ++searchRequestId;
      isLoading.value = true;
      errorMessage.value = '';
      const searchFilters = { ...filters, studio: [...(filters.studio || [])] };

      try {
        const snapshot = await getPublicReminderSnapshot({
          dateRange: getFilterDateRange(searchFilters),
          fatto: searchFilters.fatto
        });
        if (disposed || requestId !== searchRequestId) return;
        const filteredRows = applyDocumentFilters(getReminderRows(snapshot.docs), searchFilters);
        const rows = await hydrateReminderRows(filteredRows);
        if (disposed || requestId !== searchRequestId) return;
        setReminderRows(applyClientFilters(rows, searchFilters));
      } catch (error) {
        if (disposed || requestId !== searchRequestId) return;
        console.error('Errore ricerca promemoria pubblici:', error);
        errorMessage.value = 'Impossibile caricare i promemoria. Riprova tra poco.';
      } finally {
        if (!disposed && requestId === searchRequestId) isLoading.value = false;
      }
    };


    const fetchPublicReminders = () => applyAdvancedSearch(initialFilters);




    const getDateString = (ts) => {
      const d = parseDate(ts);
      return d.toISOString().split('T')[0];
    };

    const getTimeString = (ts) => {
      const d = parseDate(ts);
      const hh = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      return `${hh}:${mi}`;
    };

    const updateReminderDate = async (m, newDateStr, newTimeStr) => {
      try {
        const d = parseDate(m.data);
        let year = d.getFullYear(), month = d.getMonth(), date = d.getDate();
        let hours = d.getHours(), minutes = d.getMinutes();

        if (newDateStr) {
          [year, month, date] = newDateStr.split('-').map(Number);
          month -= 1;
        }

        if (newTimeStr) {
          [hours, minutes] = newTimeStr.split(':').map(Number);
        }

        const newDate = new Date(year, month, date, hours, minutes);
        await updateDoc(doc(db, 'comunicazioni', m.id), { data: newDate });
        m.data = newDate;
      } catch (e) {
        console.error('Errore updateReminderDate:', e);
      }
    };

    const updateReminderField = async (m, field) => {
      try {
        await updateDoc(doc(db, 'comunicazioni', m.id), { [field]: m[field] });
      } catch (e) {
        console.error(e);
      }
    };

    const updateReminderStatus = async (m, nextStatus) => {
      if (isLoading.value || savingReminderIds.value.has(m.id) || nextStatus === m.fatto) return;
      const previousStatus = m.fatto;
      cancelReminderCompletion(m.id);
      savingReminderIds.value.add(m.id);
      errorMessage.value = '';
      m.fatto = nextStatus;

      try {
        await updateDoc(doc(db, 'comunicazioni', m.id), { fatto: nextStatus });
        if (disposed || !publicReminders.value.includes(m) || nextStatus !== 'si') return;
        completingReminderIds.value.add(m.id);
        completionTimers.set(m.id, setTimeout(() => {
          cancelReminderCompletion(m.id);
          if (m.fatto !== 'si') return;
          publicReminders.value = publicReminders.value.filter(row => row.id !== m.id);
          filteredReminders.value = filteredReminders.value.filter(row => row.id !== m.id);
        }, 2000));
      } catch (error) {
        m.fatto = previousStatus;
        console.error('Errore salvataggio stato promemoria:', error);
        if (!disposed) errorMessage.value = 'Impossibile salvare lo stato. Il promemoria resta nella lista.';
      } finally {
        savingReminderIds.value.delete(m.id);
      }
    };

    const updateAssignedEmail = async (m) => {
      try {
        const cleaned = m.assignedEmailList
          .map(e => e.trim())
          .filter(e => e.length > 0)
          .join(', ');
        await updateDoc(doc(db, 'comunicazioni', m.id), { assignedEmail: cleaned });
      } catch (e) {
        console.error(e);
      }
    };

    const addAssignedEmail = (m) => {
      if (!m.assignedEmailList) m.assignedEmailList = [];
      m.assignedEmailList.push('');
    };

const deleteReminder = async id => {
  if (!confirm('Sei sicuro?')) return;
  try {
    await deleteDoc(doc(db, 'comunicazioni', id));
    // Rimuove localmente dalla tabella
    publicReminders.value = publicReminders.value.filter(r => r.id !== id);
    filteredReminders.value = filteredReminders.value.filter(r => r.id !== id);
  } catch (e) {
    console.error(e);
  }
};


    const openInNewTab = route => {
      const resolved = router.resolve(route);
      window.open(resolved.href, '_blank', 'noopener');
    };

    const viewUserProfile = uid => {
      if (!uid) return;
      openInNewTab({ name: 'UserDetails', params: { userId: uid } });
    };



const addReminder = async () => {
  try {
    if (!newReminder.value.data) {
      alert("Inserisci la data e l'ora.");
      return;
    }

    let uidToAssign = newReminderTargetUid.value || null;
    if (!uidToAssign) {
      const usersQ = query(
        collection(db, 'users'),
        where('email', '==', newReminder.value.userEmail.trim())
      );
      const usersSnap = await getDocs(usersQ);

      if (!usersSnap.empty) {
        uidToAssign = usersSnap.docs[0].id;
      } else {
        alert("Nessun utente trovato con l'email fornita.");
        return;
      }
    }

    // 🔁 Salva il documento e ottieni il riferimento
    const newDocRef = await addDoc(collection(db, 'comunicazioni'), {
      uid: uidToAssign,
      data: Timestamp.fromDate(new Date(newReminder.value.data)),
      tipo: newReminder.value.tipo || '',
      urgenza: newReminder.value.urgenza || '',
      note: newReminder.value.note || '',
      assignedEmail: newReminder.value.assignedEmail,
      tipoPromemoria: 'pubblico',
      visibilita: true,
      fatto: 'da fare'
    });

    // 🔁 Recupera subito i dati del documento
    const newDocSnap = await getDoc(newDocRef);
    const newDocData = newDocSnap.data();

    // 🔁 Inserisci manualmente in cima alla tabella
publicReminders.value.unshift({
  id: newDocRef.id,
  ...newDocData,
  userEmail: newReminder.value.userEmail,
  userName: '',
  userSurname: '',
  userPhone: '',
  userStudio: '',
  userNotes: '',
  isNew: true, // 👈 background rosso temporaneo
  assignedEmailList: newReminder.value.assignedEmail
    ? newReminder.value.assignedEmail.split(',').map(e => e.trim())
    : []
});

filteredReminders.value = [...publicReminders.value];


    // 🔁 Sincronizza anche i dati filtrati
    filteredReminders.value = [...publicReminders.value];

    // ✅ Reset e chiusura modale
    newReminder.value = {
      data: '',
      tipo: '',
      urgenza: '',
      note: '',
      userEmail: '',
      assignedEmail: '',
      tipoPromemoria: 'pubblico'
    };
    newReminderTargetUid.value = '';
    newReminderPrefillError.value = '';
    showAddModal.value = false;
  } catch (error) {
    console.error("Errore addReminder:", error);
    alert("Errore durante il salvataggio.");
  }
};


    onMounted(async () => {
      await Promise.all([
        fetchPublicReminders(),
        openReminderFromDeepLink(),
      ]);
    });
    onBeforeUnmount(() => {
      disposed = true;
      clearReminderCompletions();
    });

    return {
      expandedReminderIds,
      toggleReminderFields,
      publicReminders,
      filteredReminders,
      initialFilters,
      errorMessage,
      savingReminderIds,
      completingReminderIds,
      updateReminderStatus,
      showAddModal,
      newReminderDialog,
      closeAddReminderModal,
      handleAddReminderBackdrop,
      openAddReminderModal,
      clearLinkedReminderUser,
      newReminder,
      newReminderTargetUid,
      newReminderPrefillLoading,
      newReminderPrefillError,
      addReminder,
      viewUserProfile,
      deleteReminder,
      updateReminderDate,
      getDateString,
      getTimeString,
      updateReminderField,
      updateAssignedEmail,
      addAssignedEmail,
      showFilters,
    toggleFilters,
    filterModule,
    showModalDetails,
    reminderDetailsDialog,
    handleReminderDetailsBackdrop,
currentReminder,
openReminderDetails,
closeReminderDetails,
saveReminderDetails,
isLoading,
applyAdvancedSearch

    };
  }
};
</script>


<style scoped>
.promemoria-container tr.reminder-completed > td {
  background-color: #e5e7eb;
  color: #6b7280;
}

.promemoria-container tr.reminder-completed input,
.promemoria-container tr.reminder-completed select,
.promemoria-container tr.reminder-completed button {
  filter: grayscale(1);
  opacity: 0.65;
}

.reminder-error {
  padding: 12px 16px;
  border-radius: 10px;
  background: #fee2e2;
  color: #991b1b;
}

.new-row {
  background-color: #ecffe3 !important; /* rosso chiaro */
  transition: background-color 0.6s ease;
}


.details-button {
  padding: 6px 12px;           /* meno “ingombro” */
  border-radius: 8px;          /* raggio più piccolo */
  background-color: #4CAF50;   /* stesso verde */
  color: #fff;
  font-size: 0.9rem;           /* testo leggermente più piccolo */
  border: none;
  cursor: pointer;
  display: inline-block;       /* non usa flex per non forzare l’altezza della cella */
  text-align: center;
  min-width: 80px;             /* larghezza minima per allineamento */
}
.details-button:hover {
  opacity: 0.9;
}

.modal-content input[type="datetime-local"] {
  border-radius: 13px;
  background-color: #f1f1f116;
  padding: 14px;
  border: 1px solid #4c4c4c;
  color: rgb(211, 211, 211);
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 15px;
  width: 93%;
  font-size: 1.1rem;
}



.fab-create-small {
  position: fixed;
  bottom: 120px; /* Appena sopra il bottone filtri */
  right: 20px;
  width: 50px;
  height: 50px;
  font-size: 24px;
  font-weight: bold;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: #4caf50;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .3s, transform .2s;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  z-index: 1000;
}
.fab-create-small:hover {
  background-color: #45a049;
  transform: scale(1.1);
}



/* Styling specifico per la select di filtro ‘Stato’ */
.filter-stato {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-stato label {
  font-weight: 600;
  font-size: 16px;
}
/* Bottone filtri */
.filter-toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 100px;
  height: 100px;
  font-size: 15px;
  font-weight: bold;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .3s, transform .2s;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  z-index: 1000;
}
.filter-toggle-button:hover {
  background-color: #0056b3;
  transform: scale(1.1);
}

.action-icons {
  display: flex;
  gap: 1px;
  align-items: center;
}

.action-icons button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.action-icons button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.action-icons .material-icons {
  font-size: 20px;
  vertical-align: middle;
}


.apply-btn {
  background: #009b00;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.apply-btn:hover {
  background: #c36c00;
}
.clear-btn {
  background: none;
  border: 1px solid #ccc;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}
.clear-btn:hover {
  background: #f5f5f5;
}

/* Per la cella Note generali */
.promemoria-container td.note-generali-cell {
  white-space: pre-wrap; /* mantiene anche \n come ritorno a capo */
  word-break: break-word;
  line-height: 1.4;
}

/* Layout generale */
.promemoria-container {
  margin-top: 60px;
  margin-bottom: 70px;
}

/* Tabella con layout fisso */
.promemoria-container table {
  width: 100%;
  min-width: 1400px;
  table-layout: fixed;
  border-collapse: collapse;
}

/* Intestazione sticky */
.promemoria-container th {
  position: sticky;
  top: 27px;
  background: #f0f0f0;
  z-index: 5;
  font-weight: bold;
}

/* Celle */
.promemoria-container th,
.promemoria-container td {
  padding: 8px;
  border-bottom: 1px solid #ccc;
  text-align: left;
  white-space: nowrap;
}

.promemoria-container td > select,
.promemoria-container td > input {
  width: 100% !important;
  max-width: 100%;
  min-width: 0 !important;
  box-sizing: border-box;
}

.promemoria-container td > input[type="date"],
.promemoria-container td > input[type="time"] {
  margin: 0 !important;
  padding: 8px 26px 8px 10px;
}

/* Input assegnati email (spaziatura verticale) */
.promemoria-container td div input[type="text"] {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 5px;
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

/* Bottone + */
.promemoria-container td div button {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 6px;
  cursor: pointer;
  font-size: 0.9rem;
}

.promemoria-container td div button:hover {
  background: #ddd;
}


/* Pulsanti */
.create-user-button_orange {
  padding: 13px 15px;
  border-radius: 13px;
  background-color: #f2a100;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.create-user-button_white {
  padding: 13px 15px;
  border-radius: 13px;
  background-color: #e3e3e3;
  color: #0f0f0f;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Filtri */
.filters {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.filters label {
  font-weight: bold;
}

/* Testo colore titoli */
.promemoria-container h2 {
  color: #000;
}

/* Optional: miglioramenti generali */
thead th {
  border-bottom: 2px solid #ccc;
}

tbody tr:hover {
  background-color: #fafafa;
}

.reminder-mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .public-reminders-page .content-container,
  .public-reminders-page .content-container.sidebar-hidden {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 72px 12px 100px;
    overflow-x: hidden;
  }

  .public-reminders-page .card-container {
    padding: 0;
    margin: 0;
    min-width: 0;
    max-width: 100%;
  }

  .titolo-card {
    margin: 8px 0 20px;
  }

  .titolo-card h1 {
    margin: 0;
    font-size: 21px;
    line-height: 1.3;
  }

  .promemoria-container {
    margin: 0;
  }

  .reminder-mobile-only {
    display: block;
  }

  .reminder-desktop-only {
    display: none !important;
  }

  .promemoria-container .reminders-table,
  .promemoria-container .reminders-table tbody {
    display: block;
    width: 100%;
    min-width: 0;
    padding: 0;
    margin: 0;
    background: transparent;
    border: 0;
  }

  .reminders-table thead {
    display: none;
  }

  .promemoria-container .reminders-table tbody tr {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 10px;
    padding: 14px;
    margin-bottom: 16px;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
  }

  .promemoria-container .reminders-table td {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 5px;
    order: 10;
    width: 100% !important;
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    color: #334155;
    white-space: normal;
    overflow-wrap: anywhere;
    font-size: 13px;
  }

  .reminders-table td::before {
    content: attr(data-label);
    font-size: 11px;
    line-height: 1.4;
    font-weight: 700;
    color: #64748b;
  }

  .reminders-table .reminder-wide {
    grid-column: 1 / -1;
  }

  .promemoria-container .reminders-table .reminder-name-cell {
    order: 0;
    min-height: 44px;
    padding-right: 90px;
  }

  .reminder-person strong {
    display: block;
    color: #0f172a;
    font-size: 16px;
    line-height: 1.35;
  }

  .reminder-person > span {
    display: block;
    margin-top: 3px;
    font-size: 11px;
    color: #64748b;
  }

  .promemoria-container .reminders-table .reminder-actions-cell {
    position: absolute;
    top: 12px;
    right: 10px;
    width: auto !important;
  }

  .reminders-table .reminder-name-cell::before,
  .reminders-table .reminder-actions-cell::before,
  .reminders-table .reminder-footer-cell::before {
    display: none;
  }

  .promemoria-container .reminders-table .action-icons button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 44px;
    padding: 0;
    margin: 0;
    background: #f1f5f9;
    color: #475569;
    border-radius: 10px;
  }

  .promemoria-container .reminders-table .action-icons button:last-child {
    margin-left: 4px;
    background: #fff1f2;
    color: #be123c;
  }

  .promemoria-container .reminders-table .reminder-date-cell { order: 1; }
  .promemoria-container .reminders-table .reminder-time-cell { order: 2; }
  .promemoria-container .reminders-table .reminder-status-cell { order: 3; }
  .promemoria-container .reminders-table .reminder-urgency-cell { order: 4; }
  .promemoria-container .reminders-table .reminder-type-cell { order: 5; }
  .promemoria-container .reminders-table .reminder-note-cell { order: 6; }
  .promemoria-container .reminders-table .reminder-phone-cell { order: 7; }
  .promemoria-container .reminders-table .reminder-email-cell { order: 8; }

  .promemoria-container .reminders-table .reminder-mobile-hidden,
  .promemoria-container .reminders-table tr:not(.reminder-expanded) .reminder-secondary {
    display: none;
  }

  .promemoria-container .reminders-table input,
  .promemoria-container .reminders-table select,
  .promemoria-container .reminders-table textarea {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 44px;
    margin: 0;
    padding: 10px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    background: #f8fafc;
    color: #0f172a;
    font: inherit;
    font-size: 16px;
  }

  .promemoria-container .reminders-table td > input[type="date"],
  .promemoria-container .reminders-table td > input[type="time"] {
    padding: 8px;
  }

  .promemoria-container .reminders-table .reminder-note-input {
    height: 76px;
    resize: vertical;
    line-height: 1.5;
  }

  .reminder-contact-link {
    color: #1d4ed8;
    line-height: 1.5;
    text-decoration: none;
  }

  .promemoria-container .reminders-table .reminder-footer-cell {
    order: 99;
    flex-direction: row;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #e2e8f0;
  }

  .reminder-footer-cell .details-button,
  .reminder-footer-cell .reminder-expand-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
    min-height: 44px;
    padding: 8px;
    border: 0;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }

  .reminder-footer-cell .reminder-expand-button {
    background: #eef2ff;
    color: #3730a3;
  }

  .promemoria-container .reminders-table td div button {
    min-height: 44px;
    min-width: 44px;
  }

  .promemoria-container .reminders-table tr.reminder-completed,
  .promemoria-container .reminders-table tr.reminder-completed > td {
    background: #e5e7eb;
    color: #6b7280;
  }

  .filter-toggle-button,
  .fab-create-small {
    bottom: calc(12px + env(safe-area-inset-bottom));
    width: calc(50% - 18px);
    height: 48px;
    padding: 0 12px;
    gap: 8px;
    border-radius: 14px;
    font-size: 14px;
    box-shadow: 0 4px 18px rgba(15, 23, 42, 0.18);
    z-index: 1002;
  }

  .filter-toggle-button {
    left: 12px;
    right: auto;
  }

  .fab-create-small {
    right: 12px;
    left: auto;
  }

  .filter-toggle-button:hover,
  .fab-create-small:hover {
    transform: none;
  }

  .public-reminders-page .modal {
    box-sizing: border-box;
    inset: 0;
    width: 100%;
    height: 100%;
    padding: 12px;
    z-index: 1100;
  }

  .modal .modal-content {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    max-width: 480px;
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    padding: 20px 16px;
    border-radius: 18px;
    background: #fff;
    color: #0f172a;
    overscroll-behavior: contain;
  }

  .modal-content h2 {
    padding-right: 36px;
    margin: 0 0 20px;
    font-size: 19px;
    text-align: left;
    color: #0f172a;
  }

  .modal-content .close {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    color: #475569;
  }

  .modal-new-info form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .modal-new-info form > div {
    width: 100%;
    min-width: 0;
    margin: 0;
  }

  .modal-new-info form label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 700;
    color: #475569;
  }

  .modal-new-info .modal-content input,
  .modal-new-info .modal-content select,
  .modal-new-info .modal-content textarea {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    min-height: 44px;
    margin: 0;
    padding: 10px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    background: #f8fafc;
    color: #0f172a;
    font-size: 16px;
  }

  .modal-new-info .modal-content textarea {
    height: 110px;
  }

  .modal-new-info form > button {
    width: 100%;
    min-height: 48px;
    margin: 4px 0 0;
    padding: 12px;
    font-size: 16px;
  }
}
</style>
<style scoped src="../../assets/css/staff-reminder-controls.css"></style>

<style scoped src="../../assets/css/staff-reminders-table.css"></style>

<style scoped src="../../assets/css/staff-editor-dialog.css"></style>
